<template>
  <div class="card floating" id="open-private-space">
    <img src="/img/icons/privateSpacesIcon/safebox-main-icon.svg">
    <h2 v-if="createMode === 1">{{ $t('prompts.openPrivateSpace') }}</h2>
    <h2 v-if="createMode === 2">{{ $t('buttons.openSpaceWithRecoveryKey') }}</h2>
    <input v-if="createMode === 1" class="input input--block" v-focus type="text" v-model="name" :placeholder="$t('prompts.folderName')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    <input v-if="createMode === 1" class="input input--block" type="password" v-model="password" :placeholder="$t('login.password')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    <button v-if="createMode === 1 && permissions === 0" id="openButtonSecretKey" @click="openPrivateSpaceSecretKey" :aria-label="$t('buttons.openSpaceWithRecoveryKey')" :title="$t('buttons.openSpaceWithRecoveryKey')">
      <span>{{ $t('buttons.openSpaceWithRecoveryKey') }}</span>
    </button>
    <p class="info" v-if="createMode === 2">{{ $t('prompts.recoverSpace') }}</p>
    <input v-if="createMode == 2" class="input input--block" v-focus type="text" v-model="recoveryKey" :placeholder="$t('pricing.downloadRecoveryKey')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    <input v-if="createMode == 2" class="input input--block" type="text" v-model="name" :placeholder="$t('prompts.folderName')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    <div class="password" v-if="createMode == 2">
      <input class="input input--block" type="password" v-model="password" :placeholder="$t('login.password')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
      <input class="input input--block" type="password" v-model="passwordConfirm" :placeholder="$t('login.passwordConfirm')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    </div>
    <div class="aviso">
      <img src="/img/icons/privateSpacesIcon/folder-alert-icon.svg">
      <p>{{ $t('prompts.secondLayerSecurity') }}<b>{{ $t('prompts.saveData') }}</b></p>
    </div>
    <div class="botones">
      <button id="cancelButton" @click="cancel" :aria-label="$t('buttons.cancel')" :title="$t('buttons.cancel')">
        <span>{{ $t('buttons.cancel') }}</span>
      </button>
      <button id="openButton" @click="openPrivateSpace" :aria-label="$t('prompts.openPrivateSpace')" :title="$t('prompts.openPrivateSpace')" :disabled="comprobarDatos">
        <span>{{ $t('prompts.openPrivateSpace') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
export default {
  name: 'open-private-space',
  data: function () {
    return {
      name: '',
      password: '', 
      handle: '',
      createMode: 1,
      recoveryKey: '',
      passwordConfirm: ''
    };
  },
  computed: {
    ...mapState([
      'permissions'
    ]),
    comprobarDatos() {
      if (this.createMode === 1) {
        if (this.name !== '' && this.password !== '') {
          return false;
        } else {
          return true;
        }
      } else {
        if (this.name !== '' && this.password !== '' && this.recoveryKey !== '' && this.passwordConfirm !== '') {
          return false;
        } else {
          return true;
        }
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyEvent);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keyEvent);
  },
  methods: {
    ...mapMutations(['closeHovers', 'setHandleOpenSpace']),
    async openPrivateSpace() {
      if (this.createMode === 1) {
        this.open();
      } else {
        if (this.password === this.passwordConfirm) {
          let action = await ibb.recoverSecret(this.recoveryKey, this.name, this.password);
          if (action.error.type === 1) {
            this.$showError(this.$t('prompts.incorrectData'));
          } else if (action.error.type === 7) {
            this.$showError(this.$t('prompts.alreadyExists'));
          } else  if (!action.error.type) {
            this.handle = action.node.handle;
            this.setHandleOpenSpace(this.handle);
            this.$router.push({path: '/sec' + '#' + this.handle});
            this.$store.commit('closeHovers');
          }
        } 
      }
    },
    async open() {
      let action = await ibb.openSecret(this.name, this.password);
      if (action.error.type === 1) {
        this.$showError(this.$t('prompts.incorrectData'));
      } else if (!action.error.type) {
        this.handle = action.node.handle;
        this.setHandleOpenSpace(this.handle);
        this.$router.push({path: '/sec' + '#' + this.handle});
        this.$store.commit('closeHovers');
      }
    },
    keyEvent (event) {
      // Enter
      if (event.keyCode === 13) {
        if (this.createMode === 1 && this.name !== '' && this.password !== '') {
          this.open();
        }
      }
    },
    openPrivateSpaceSecretKey() {
      this.createMode = 2;
    },
    cancel() {
      if (this.createMode === 1) {
        this.$store.commit('closeHovers');
      } else {
        this.createMode = 1;
      }
    }
  }
};
</script>